<app-contract-form
  [edit]="true"
  [id]="id"
  [(value)]="value"
  [access]="access()"
></app-contract-form>
